import { LoginTemplate } from '@partiu/ui/templates/LoginTemplate.tsx';
import { useNavigate } from 'react-router-dom';
import { useToast } from '@chakra-ui/react';
import { useAgreementDataMutation } from '@partiu/api/dashboard/hooks.ts';
import { isAuthenticated, setAccessToken } from '@partiu/api/axios.ts';
import { useTheme } from '@partiu/ui/contexts/ThemeProvider.tsx';
import { useEffect } from 'react';
import { updateThemeWithAgreement } from '@partiu/ui/utils.ts';

export function LoginPage() {
  const navigate = useNavigate();
  const toast = useToast();
  const { updateTheme, colors } = useTheme();
  const { mutate } = useAgreementDataMutation({
    onSuccess(data) {
      updateThemeWithAgreement(data, colors, updateTheme);
      navigate('/dashboard');
    },
    onError() {
      toast({
        title: 'Oops!',
        description: 'Este usuário não tem acesso ao Sistema Dashboard',
        status: 'error',
      });
      setAccessToken(null);
    },
  });

  useEffect(() => {
    if (isAuthenticated()) mutate();
  }, []);

  return (
    <LoginTemplate
      image={
        'https://zenklub.com.br/blog/wp-content/uploads/2022/08/zenklub-blog-empresas-que-investem-bem-estar-dos-funcionarios.jpg'
      }
      onLoginSuccess={() => mutate()}
      siteName={'Dashboard'}
    ></LoginTemplate>
  );
}
